<template>
    <a-card :bordered="false" class="m-b-20">
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="请选择">
          <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
            <a-select-option value="1">日</a-select-option>
            <a-select-option value="2">自然周</a-select-option>
            <a-select-option value="3">自然月</a-select-option>
            <a-select-option value="4">近7天</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="">
          <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
          <a-week-picker v-model:value="weekTime" v-else-if="search.search_date_type=='2'" />
          <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM' />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' @click="onSearch">搜索</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card :bordered="false" class="m-b-20">
      <div class="data-content-nav s_flex_ali">
        <div class="data-content-nav-item flex_1 s_flex_center" :class="active==v.key?'active':''" @click="changNav(v.key)" v-for="(v,k) in TBAS" :key="k">
          <div>
            <p class='title'>{{v.title}}</p>
            <p class='num'>{{statistics_data[v.key]}}</p>
          </div>
        </div>
      </div>
      <div ref="echartsLine" style="width:100%;height:400px"></div>
    </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { onMounted } from "@vue/runtime-core";
import { statisticsGoods, statisticsGoodsChart } from "@/api/online";
import { message } from "ant-design-vue";
const TBAS = [
  {
    title: "成功下单件数",
    key: "pay_goods_num",
    id: 1,
  },
  {
    title: "成功下单积分",
    key: "pay_point_price_total",
    id: 2,
  },
  {
    title: "成功退款件数",
    key: "refund_goods_num",
    id: 3,
  },
  {
    title: "成功退款积分",
    key: "refund_point_price_total",
    id: 4,
  },
];
export default {
  components: {},
  setup() {
    const search = ref({
      search_date_type: "1",
      search_time: "",
    });
    const state = reactive({
      active: "1",
      statistics_data: {},
      chartsData: {},
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { typeToStartEnd,dateTargets } = useTime();
       // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = dateTargets();
          break;
        case "2":
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
            dateTime.weekTime=typeToStartEnd("week").end_time
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          break;
      }
    };
    const initData = async () => {
      let result = await statisticsGoods(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      state.statistics_data = result.data;
    };
    const initCharts = async () => {
      let result = await statisticsGoodsChart({
        ...search.value,
        data_type: state.active,
      })
        .then((res) => res.data)
        .catch((error) => error);
      return result.data;
    };
    const onSearch = async () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      await initData();
      state.chartsData = await initCharts();
      changNav(state.active);
    };
    // 线性图表
    const echartsLine = ref("");
    var line;
    const changNav = async (e) => {
      state.active = e;
      var target=TBAS.filter(v=>v.key==e)[0]
      line = useECharts(echartsLine.value);
      line.setOptions({
      tooltip: {
          trigger: "axis",
         formatter: `{b}<br/>${target.title}:{c}`,
        },
        xAxis: {
          type: "category",
          data: Object.keys(state.chartsData[state.active + "_data"]),
        },
        yAxis: {
          name: "昨天全天0",
          type: "value",
        },
        series: [
          {
            data: Object.values(state.chartsData[state.active + "_data"]),
            type: "line",
            smooth: true,
          },
        ],
      });
    };
    onMounted(async () => {
       handleChange("1")
      await initData();
      state.chartsData = await initCharts();
      changNav("pay_goods_num");
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      changNav,
      onSearch,
      echartsLine,
      TBAS,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;
  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }
    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>